import type { FormLogInput } from "./schema";

type LogInput = FormLogInput;

async function send(input: LogInput): Promise<boolean> {
  const tokenRes = await fetch("/api/public/form-log", { method: "GET", cache: "no-store" });
  if (!tokenRes.ok) return false;
  const { token } = (await tokenRes.json().catch(() => ({}))) as { token?: string };
  if (!token) return false;
  const res = await fetch("/api/public/form-log", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    keepalive: true,
    body: JSON.stringify({ ...input, token, website: "" }),
  });
  return res.ok;
}

/**
 * Internal backup of a form submission sent straight to the HubSpot Forms API
 * from the browser. Called on BOTH HubSpot success and failure so leads are
 * never lost. Retries once. Never throws; resolves to whether the backup saved.
 */
export function logFormSubmission(input: LogInput): Promise<boolean> {
  return (async () => {
    for (let attempt = 0; attempt < 2; attempt++) {
      try {
        if (await send(input)) return true;
      } catch {
        /* retry */
      }
    }
    console.error("[form-log] backup failed", input.formType, input.formName);
    return false;
  })();
}

/** Short reason string for a failed HubSpot response or thrown error. */
export function hubspotFailReason(statusOrErr: number | unknown): string {
  if (typeof statusOrErr === "number") return `hubspot_http_${statusOrErr}`;
  return "hubspot_network_error";
}
